import React from 'react';
import PropTypes from 'prop-types';

const FindCareHeader = (props) => {
  if (!props.Heading) return null;

  const formatHeadingHtml = (heading) => ({
    __html: heading.replace('domsmottagning', 'doms&shy;mottagning'),
  });

  return (
    <div className="row">
      <div className="large-8 large-centered columns">
        <div className="findcare-header">
          <h1 dangerouslySetInnerHTML={formatHeadingHtml(props.Heading)} />
          {props.Preamble && (
            <p className="findcare-header__preamble">{props.Preamble}</p>
          )}
        </div>
      </div>
    </div>
  );
};

FindCareHeader.propTypes = {
  /** `h1` element */
  Heading: PropTypes.string,
  /** `p.findcare-header__preamble` */
  Preamble: PropTypes.string,
};

export default FindCareHeader;
